import { api } from 'services/api';

export const commonService = api.injectEndpoints({
  endpoints: (builder) => ({
    faqs: builder.query<ResultModel<FaqData[]>, void>({
      query: () => ({
        url: `/573D6FBC30D637/Faq`,
        method: 'POST',
      }),
    }),
    nationalities: builder.query<ResultModel<Nationality[]>, void>({
      query: () => ({
        url: `/573D6FBC30D637/NationalityList`,
        method: 'POST',
      }),
    }),
    genders: builder.query<ResultModel<Gender[]>, void>({
      query: () => ({
        url: `/573D6FBC30D637/GenderList`,
        method: 'POST',
      }),
    }),
    insuranceCompanies: builder.query<ResultModel<InsuranceCompany[]>, void>({
      query: () => ({
        url: `/573D6FBC30D637/InsuranceCompanies`,
        method: 'GET',
      }),
    }),
    petGenders: builder.query<ResultModel<Gender[]>, void>({
      query: () => ({
        url: `/573D6FBC30D637/PetGenders`,
        method: 'POST',
      }),
    }),
    petTypes: builder.query<ResultModel<PetType[]>, void>({
      query: () => ({
        url: `/573D6FBC30D637/PetTypes`,
        method: 'POST',
      }),
    }),
    petBreeds: builder.query<ResultModel<PetBreed[]>, { petTypeId: number }>({
      query: ({ petTypeId }) => ({
        url: `/573D6FBC30D637/PetBreeds`,
        method: 'POST',
        params: {
          petTypeId,
        },
      }),
    }),
    cities: builder.query<ResultModel<City[]>, void>({
      query: () => ({
        url: `/573D6FBC30D637/CityList`,
        method: 'POST',
      }),
    }),
    towns: builder.query<ResultModel<Town[]>, TownRequest>({
      query: (body) => ({
        url: `/573D6FBC30D637/TownList`,
        method: 'POST',
        body,
      }),
    }),
    districts: builder.query<ResultModel<District[]>, DistrictRequest>({
      query: (body) => ({
        url: `/573D6FBC30D637/DistrictList`,
        method: 'POST',
        body,
      }),
    }),
    neighborhoods: builder.query<ResultModel<Neighborhood[]>, NeighborhoodRequest>({
      query: (body) => ({
        url: `/573D6FBC30D637/NeighbornhoodList`,
        method: 'POST',
        body,
      }),
    }),
    filteredHospitals: builder.query<ResultModel<FilteredHospital[]>, FilterHospitalsRequest>({
      query: (body) => ({
        url: `/573D6FBC30D637/FilterHospitals`,
        method: 'POST',
        body,
      }),
    }),
    appointmentUnitsCommon: builder.query<ResultModel<AppointmentUnit[]>, AppointmentUnitsRequest>({
      query: (body) => ({
        url: `/573D6FBC30D637/AppointmentUnits`,
        method: 'POST',
        body,
      }),
    }),
    filteredDoctorsCommon: builder.query<ResultModel<FilteredDoctor[]>, FilterDoctorsRequest>({
      query: (body) => ({
        url: `/573D6FBC30D637/FilterDoctors`,
        method: 'POST',
        body,
      }),
    }),
    filteredDoctorsForPatient: builder.query<
      ResultModel<FilteredForPatientDoctor[]>,
      FilterDoctorsForPatientRequest
    >({
      query: (body) => ({
        url: `/573D6FBC30D637/FilterDoctorsForPatient`,
        method: 'POST',
        body,
      }),
      extraOptions: { isProfile: true },
    }),
    hairdresserServices: builder.query<ResultModel<HairdresserService[]>, { languageId: number }>({
      query: (body) => ({
        url: `/573D6FBC30D637/HairdresserService/List`,
        method: 'POST',
        body,
      }),
    }),
    createContactForm: builder.mutation<ResultModel<void>, ContactFormRequest>({
      query: (body) => ({
        url: `/573D6FBC30D637/CreateContactForm`,
        method: 'POST',
        body,
      }),
    }),
    captcha: builder.query<ResultModel<CaptchaResponse>, CaptchaRequest>({
      query: (body) => ({
        url: `/573D6FBC30D637/Captcha`,
        method: 'POST',
        body,
      }),
    }),
    visitTypes: builder.query<ResultModel<VisitType[]>, void>({
      query: (body) => ({
        url: `/573D6FBC30D637/VisitTypes`,
        method: 'POST',
        body,
      }),
    }),
    filteredHospitalsForPatient: builder.query<
      ResultModel<FilteredHospitalForPatient[]>,
      FilterHospitalsForPatientRequest
    >({
      query: (body) => ({
        url: `/573D6FBC30D637/FilterHospitalsForPatient`,
        method: 'POST',
        body,
      }),
      extraOptions: { isProfile: true },
    }),
    applicationInfo:builder.query<ResultModel<ApplicationInfo>, ApplicationInfoRequest>({
      query:(body)=>({
        url:'/573D6FBC30D637/application-info.json',
        method:'POST',
        body
      })
    })
  }),
});

export const {
  useFaqsQuery,
  useNationalitiesQuery,
  useGendersQuery,
  useInsuranceCompaniesQuery,
  usePetGendersQuery,
  usePetTypesQuery,
  usePetBreedsQuery,
  useCitiesQuery,
  useTownsQuery,
  useDistrictsQuery,
  useNeighborhoodsQuery,
  useFilteredHospitalsQuery,
  useAppointmentUnitsCommonQuery,
  useFilteredDoctorsCommonQuery,
  useHairdresserServicesQuery,
  useCreateContactFormMutation,
  useCaptchaQuery,
  useVisitTypesQuery,
  useFilteredHospitalsForPatientQuery,
  useFilteredDoctorsForPatientQuery,
  useApplicationInfoQuery
} = commonService;

